module.exports = __webpack_public_path__ + "img/kws_gray.00f757e0.svg";